import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ListWithDescription from "@/components/elements/CustomLists/ListWithDescription";
import ImageWithContentLeft from "@/components/elements/ImageWithContent/ImageWithContentLeft";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import p1 from "@/assets/images/services/polyurethane.jpg"

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const PolyurethaneWaterproofing = () => {
  return (
    <div className="pb-0 px-4  2xl:px-40 xl:px-40 md:px-[3rem] my-[5rem]">
      <TitleBar title="Polyurethane Waterproofing" />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeft alt="Polyurethane Waterproofing"
          imageUrl={p1}
          title="Description"
          content={
            <>
              <span className="span-text">Polyurethane waterproofing</span> stands as a pinnacle of modern construction technology, offering unparalleled protection against water infiltration and damage to structures. As a versatile and highly effective solution, polyurethane waterproofing has revolutionized the way we safeguard buildings, bridges, tunnels, and other critical infrastructure from the corrosive effects of moisture. <br />
              Polyurethane waterproofing encompasses a range of advanced materials and application techniques designed to create seamless barriers against water ingress. These innovative solutions leverage the unique properties of polyurethane polymers to deliver exceptional performance in diverse environments and applications.
            </>
          }
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Applications of Polyurethane-Based Waterproofing Systems">
        <CustomLists
        layout="split"
        items={[[
            "Used as a topcoat on wood, ceramic, and similar materials for waterproofing, dust protection, and an enhanced finish.",
            "Ideal for potable water tanks due to corrosion resistance, durability, and non-toxicity.",
            "Seals cracks in tunnels, bridges, and concrete walls—also used as injection systems to stop active leaks.",
        ],
        [
            "Effective in wet or damp areas, both indoors and outdoors, serving as grouting mastic or filler.",
            "Applied as a protective floor coating on concrete and cement surfaces for internal and external use."
        ]]}
        />
        </TitleWithContent>
      </motion.div>


      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages of Polyurethane Waterproofing">
          <CustomLists
          layout="split"
            items={[[
              "Long-term protection",
              "High flexibility performance",
              "Resistance to UV lights and weather conditions",
              "Highly load carrying capacity",
              "High resistance to abrasion and impact",
              "Resistance to mold and fungus",
            ],
            [
              "Resistance to freezing temperature",
              "Strong adhesion",
              "Easy and fast installation",
              "Perfect and aesthetic appearance",
              "Resistance to corrosion",
            ]]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Application Steps">
          <ListWithDescription
            layout="stacked"
            titleListType="decimal"
            items={[
              {
                title: "Surface Preparation",
                content: [
                  "Clean and dry the surface thoroughly. Remove dust, oil, and debris.",
                  "Repair any cracks or holes using suitable fillers and allow them to cure."
                ]
              },
              {
                title: "Priming (if required)",
                content: [
                  "Apply a compatible polyurethane primer to porous or unstable surfaces.",
                  "Allow it to dry fully before applying the membrane."
                ]
              },
              {
                title: "First Coat Application",
                content: [
                  "Apply the first coat evenly using a brush, roller, or spray.",
                  "Ensure consistent coverage and proper thickness per product guidelines."
                ]
              },
              {
                title: "Reinforcement (Optional)",
                content: [
                  "Embed fabric or mesh into the first coat in high-stress areas (e.g., corners, joints).",
                  "This adds strength and enhances crack-bridging."
                ]
              },
              {
                title: "Second Coat Application",
                content: [
                  "Once the first coat has cured, apply a second coat for complete sealing.",
                  "Maintain the recommended total thickness (usually 2–3 mm)."
                ]
              },
              {
                title: "Topcoat (Optional)",
                content: [
                  "Apply a UV-resistant or wear-resistant topcoat for exposed or trafficable surfaces.",
                  "This enhances durability and aesthetic finish."
                ]
              },
              {
                title: "Curing and Final Inspection",
                content: [
                  "Let the system cure as per manufacturer instructions (24–72 hrs).",
                  "Inspect for uniformity, seal weak points, and test if required."
                ]
              }
            ]}
          />
          <div className="py-8">
            <Paragraph content="Following these concise steps ensures durable and effective polyurethane waterproofing performance across various applications." />
          </div>
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Why Choose Us for Polyurethane Waterproofing?">
          <Paragraph
            content={
              <>
                At <span className="span-text">Sheel Waterproofing</span>, we offer premium-grade polyurethane waterproofing systems designed to ensure complete moisture protection, structural durability, and aesthetic integrity. Here’s what sets us apart:
              </>
            }
          />
          <CustomLists
            listStyle="none"
            layout="stacked"
            items={[[
              "Cutting-edge polyurethane solutions for diverse environments and applications",
              "Expert assessment and custom-designed waterproofing plans",
              "Flawless application techniques ensuring seamless coverage",
              "Reliable long-term performance for both commercial and residential structures"
            ]]}
            bullets={[["🧪", "📋", "🎯", "🏠"]]}
          />
          <Paragraph
            content={
              <>
                Whether it's for rooftops, basements, or critical infrastructure, trust <span className="span-text">Sheel Waterproofing</span> to provide state-of-the-art protection. <br /><br />
                <a href="/contact" className="text-custom-hov underline">Contact us today</a> to schedule a consultation or request a quote.
              </>
            }
          />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default PolyurethaneWaterproofing;
